import clsx from 'clsx';
import { getUrgencyTier, formatDaysUntilDue } from '@utils/reassessmentUtils';
import type { ReassessmentStatus } from '@app-types/contract';
import type { UrgencyTier } from '@utils/reassessmentUtils';
import styles from './ReassessmentStatusCell.module.css';

interface ReassessmentStatusCellProps {
  reassessmentStatus: ReassessmentStatus | null | undefined;
}

const DOT_CLASS: Record<UrgencyTier, string> = {
  red:    styles.dotRed,
  yellow: styles.dotYellow,
  green:  styles.dotGreen,
  gray:   styles.dotGray,
};

export function ReassessmentStatusCell({ reassessmentStatus }: ReassessmentStatusCellProps) {
  if (!reassessmentStatus || !reassessmentStatus.status) return null;

  const { status, days_until_due } = reassessmentStatus;
  const tier = getUrgencyTier(days_until_due);

  return (
    <div className={styles.cell}>
      <span className={clsx(styles.dot, DOT_CLASS[tier])} />
      <span className={styles.status}>{status}</span>
      {days_until_due !== null && <span className={styles.days}>{formatDaysUntilDue(days_until_due)}</span>}
    </div>
  );
}
